'use strict';
import get from 'lodash/get';
import {extendPrototypeResult as localforage} from 'localforage-indexes';
import lruDriver from '../../_libs/localforage-migrations';
import StorageProvider from 'storage';
import * as ENVIRONMENTS_ENUM from './environments';

export * from './build-target';

export const ENVIRONMENTS = ENVIRONMENTS_ENUM;

export const LOG_LEVEL = process.env.LOG_LEVEL;
export const FILESTACK_API_KEY = process.env.FILESTACK_API_KEY;
export const FILESTACK_STORE = process.env.FILESTACK_STORE;
export const CLIENT_VERSION = process.env.VERSION;
export const BUILD_DATE = process.env.BUILD_DATE;
export const ENVIRONMENT = process.env.ENVIRONMENT;
export const FBURL = process.env.FBURL;
export const APP_NAME = process.env.APP_NAME;
export const APP_URL = process.env.APP_URL;
export const API_URL = process.env.API_URL;
export const FILE_GATEWAY_API_URL = process.env.FILE_GATEWAY_API_URL;
export const ZIP_API_URL = process.env.ZIP_API_URL;
export const ROOT_API_COLLECTION = '_root-api-queue';
export const ROOT_API_SPEC = 'default_api';
export const APPLICATION_SERVER_PUBLIC_KEY = process.env.APPLICATION_SERVER_PUBLIC_KEY;

export const TOS_URL = process.env.TOS_URL;
export const PRIVACY_URL = process.env.PRIVACY_URL;

export const GOOGLE_MAPS_KEY = process.env.GOOGLE_MAPS_KEY;
export const OPEN_TOK_KEY = process.env.OPEN_TOK_KEY;
export const MAX_VIDEO_PARTICIPANTS = get(process.env, 'MAX_VIDEO_PARTICIPANTS', 5);

export const storageProvider = new StorageProvider();
export const storage = storageProvider.createStore();
export const localForageConfig = {
  name: 'SwiftProjects',
  version: 1,
//  size        : 4980736, // Size of database, in bytes. WebSQL-only for now.
  storeName: 'redux-storage',
  description: 'Cache application state tree',
};
localforage.defineDriver(lruDriver).catch(err => {
  console.error(`Failed to define storage driver`, err);
});
export const asyncStorage = localforage.createInstance(localForageConfig);

export const LANDING_VIEW = 'app.user-home';

/**
 * @type {{LOG_LEVEL: (*), FILESTACK_API_KEY: (*), FILESTACK_STORE: (*), CLIENT_VERSION, BUILD_DATE: *}}
 * @deprecated
 */
export const APP_ENV = {
  LOG_LEVEL: LOG_LEVEL,
  FILESTACK_API_KEY: FILESTACK_API_KEY,
  FILESTACK_STORE: FILESTACK_STORE,
  CLIENT_VERSION: CLIENT_VERSION,
  BUILD_DATE: BUILD_DATE,
};



// WEBPACK FOOTER //
// ./src/js/config/constants/index.js